import React, { useEffect, useState } from "react";
import HeroBanner from "../../components/HeroBanner";
import NavigationTabs from "../../components/NavTabs";
import SummaryContent from "../../components/SummaryContent";
import Discover from "../../components/Discover";
import { endpoints, hostName } from "../../utils/Constants";
import Media from "../../components/EventMedia";
import EventsSection from "../../components/EventsSections";
import { artistNodeId } from "../../utils/Utils";
import useDevice from "../../hooks/useDevice";
import useOnScreen from "../../hooks/useOnScreen";

const ArtistApp = () => {
  const [media, setMedia] = useState([]);
  const [artistData, setArtistData] = useState({});
  const [loading, setLoading] = useState(true);
  const [mediaLoading, setMediaLoading] = useState(true);
  const { isDesktop } = useDevice();

  let navBarThresholdElementId = "HeroBanner";

  let header = document.getElementById(navBarThresholdElementId);

  const headerVisible = useOnScreen(header, true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    let culture = $("#lng").val();

    fetch(endpoints.event.getArtist(artistNodeId(), culture), {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
        setArtistData(result);
        setLoading(false);
      })
      .catch((error) => {
        console.error(`Can't fetch artist!`, error);
        setLoading(false);
      });

    fetch(endpoints.event.getArtistMedia(artistNodeId(), culture), {
      method: "GET",
    })
      .then((res) => res.json())
      .then((result) => {
        let media = result.map((item) => ({ src: item }));
        setMedia(media);
        setMediaLoading(false);
      })
      .catch((error) => {
        console.error(`Can't fetch media!`, error);
        setMediaLoading(false);
      });
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <HeroBanner data={artistData} loading={loading} />

        <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
          <NavigationTabs
            hasMedia={true}
            context={"Entity"}
            pageInfoProp={{
              producerCount: 0,
            }}
            buttonText={artistpage_resources.Tickets}
            loading={loading}
            headerVisible={headerVisible}
          />

          <SummaryContent
            data={artistData}
            desc={{ description: artistData.description }}
            loading={loading}
            context={"Entity"}
          />

          {!isDesktop && <Discover data={artistData} loading={loading} />}

          <Media
            mainUrl={hostName}
            media={media}
            loading={mediaLoading}
            context={"Entity"}
          />

          <EventsSection headerVisible={headerVisible} />
        </div>
      </div>
    </>
  );
};

export default ArtistApp;
